(() => {
  const loaderKey = document.currentScript?.dataset.sentryLoaderKey;
  if (!loaderKey || window.nmnSentryScheduled || window.Sentry) return;

  window.nmnSentryScheduled = true;

  const loadSentry = () => {
    if (
      window.Sentry ||
      document.querySelector(`script[src*="sentry-cdn.com/${loaderKey}.min.js"]`)
    ) return;

    const script = document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = `https://js-de.sentry-cdn.com/${encodeURIComponent(loaderKey)}.min.js`;
    document.head.append(script);
  };

  const scheduleSentry = () => {
    // Keep Sentry's loader and SDK off the initial page-load network/rendering path.
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(loadSentry, { timeout: 2000 });
    } else {
      window.setTimeout(loadSentry, 1500);
    }
  };

  if (document.readyState === "complete") {
    scheduleSentry();
  } else {
    window.addEventListener("load", scheduleSentry, { once: true });
  }
})();
